export default __webpack_public_path__ + "img/logo-instagram.1112dbf5.svg";